import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { api_routes } from '@app/consts';
import { catchError, map } from 'rxjs/operators';
import { FamilyDependant } from '../models/family-dependant.model';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class FamilyDependantService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getFamilyDependants(employeeId: string, take?: number, skip?: number): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.FAMILYS}`, {
      headers: headers,
      params: params
    })
    .pipe(
      catchError(err => throwError(err)),
      map(res => {
        let data = {
          data: res.data,
          total: res.total
        }

        return data;
      })
    );
  }

  getFamilyDependant(employeeId: string, FamilyDependantId: string): Observable<FamilyDependant> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.FAMILYS}/${FamilyDependantId}`, {
      headers: headers
    });
  }

  deleteFamilyDependant(employeeId: string, FamilyDependantId: string) {
    return this.http.delete<any>(
      `${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.FAMILYS}/${FamilyDependantId}`, {
      headers: headers
    });
  }

  createNewFamilyDependant(employeeId: string, FamilyDependantSubmit: any): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.FAMILYS}`, FamilyDependantSubmit, {
      headers: headers
    });
  }

  updateFamilyDependant(employeeId: string, FamilyDependantSubmit: any): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.FAMILYS}/${FamilyDependantSubmit.id}`, FamilyDependantSubmit, {
      headers: headers
    });
  }
}
